import {TelegramAccount} from "../types/telegram-page.types";

export const defaultAccount: TelegramAccount = {
  accountId: '',
  accountName: '',
  photoRemoteId: ''
}
